import Input from './Input.jsx'

export default Input
